// src/utils/dxcc-utils.js
import { DXCC_LIST } from '../data/dxcc.js';

export function normalizeText(value) {
    return String(value ?? '').trim().toLowerCase();
}

function allTerms(e) {
    return [e.name, ...(e.aliases ?? [])].map(t => t.toLowerCase());
}

export function searchDxcc(query, limit = 25) {
    const q = normalizeText(query);
    if (!q) return DXCC_LIST.slice(0, limit);

    const codeMatch = String(q);
    const seen = new Set();

    const exact    = [];
    const startsWith = [];
    const includes  = [];

    for (const e of DXCC_LIST) {
        const terms = allTerms(e);
        const label = `${e.name} (${e.dxcc})`.toLowerCase();
        const isCode = String(e.dxcc) === codeMatch;

        if (isCode || terms.some(t => t === q)) {
            exact.push(e); seen.add(e);
        } else if (terms.some(t => t.startsWith(q)) || label.startsWith(q)) {
            startsWith.push(e); seen.add(e);
        } else if (terms.some(t => t.includes(q)) || label.includes(q)) {
            includes.push(e); seen.add(e);
        }
    }

    return [...exact, ...startsWith, ...includes].slice(0, limit);
}

export function getDxccByCode(code) {
    const n = Number(code);
    return DXCC_LIST.find(e => e.dxcc === n) ?? null;
}

export function getDxccByLabel(label) {
    return DXCC_LIST.find(e => `${e.name} (${e.dxcc})` === label) ?? null;
}
